import { Box } from '@mui/material';
import { PortalTableCell } from '../../styles/portalListTable';
import { NON_LIVE_PARTNER_CELL_SX } from '../../utils/partnerStatus';

const PartnerLiveOnlyCell = ({ isLive, align, children }) => (
  <PortalTableCell align={align}>
    <Box sx={isLive ? undefined : NON_LIVE_PARTNER_CELL_SX}>{children}</Box>
  </PortalTableCell>
);

export default PartnerLiveOnlyCell;
